const ArroweExpand = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="14"
    viewBox="0 0 23 14"
    fill="none"
  >
    <path
      d="M0.439339 13.1818C-0.146448 12.596 -0.146448 11.6462 0.439339 11.0604L11.5 -0.00022798L22.5607 11.0604C23.1464 11.6462 23.1464 12.596 22.5607 13.1818C21.9749 13.7675 21.0251 13.7675 20.4393 13.1818L11.5 4.24241L2.56066 13.1818C1.97487 13.7675 1.02513 13.7675 0.439339 13.1818Z"
      fill="currentColor"
    />
  </svg>
);
export default ArroweExpand;
